import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import safelyEvalAdScript from '../utils/safelyEvalAdScript';
import IndexPage from 'flarum/forum/components/IndexPage';
import refreshAds from '../utils/refreshAds';
import { slug } from '../../common';

export default function insertAdsIntoIndexPage() {
	extend(IndexPage.prototype, 'contentItems', function (items) {
		const adSenseTags = app.forum.attribute('adSenseTags') as number[] | undefined;

		if (!adSenseTags || adSenseTags.length === 0) return;

		const currentTagId = Number(this.currentTag()?.id());

		if (!currentTagId || !adSenseTags.includes(currentTagId)) return;

		const code = app.forum.attribute<string>(`${slug}.adsenseTestCode`);

		const html = m.trust(code);

		items.add('adsense', <div className="ad-wrap">{html}</div>, 95);
	});

	extend(IndexPage.prototype, ['oncreate', 'onupdate'], function () {
		// For now this is just duplicated logic as the other extender as it's just
		// a POC to see if it works.
		// In the future this should be refactored to avoid duplication.

		const adSenseTags = app.forum.attribute('adSenseTags') as number[] | undefined;

		if (!adSenseTags || adSenseTags.length === 0) return;

		const currentTagId = Number(this.currentTag()?.id());

		if (!currentTagId || !adSenseTags.includes(currentTagId)) return;

		const script = app.forum.attribute<string>(`${slug}.adsenseTestScript`);

		refreshAds();
		safelyEvalAdScript(script);
	});
}
